const images = document.querySelectorAll('[data-src]');

/**
 * Replace img src with data source.
 * @constructor
 * @param {Object} img - The title of the book.
 */
function preloadImage(img) {
    const src = img.getAttribute('data-src');
    const sibling = img.previousElementSibling;

    if (sibling != null) {
        if (sibling.hasAttribute('data-srcset')) {
            sibling.srcset = sibling.getAttribute('data-srcset');
        }
    }

    if (src) {
        img.src = src;
        img.classList.add('lazyLoaded');
    }
}
const imgOptions = {};

const imgObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            preloadImage(entry.target);
            if (entry.target.classList.contains('lazyLoaded')) {
                imgObserver.unobserve(entry.target);
            }
        } else {
            return;
        }
    });
}, imgOptions);

images.forEach(image => {
    imgObserver.observe(image);
});
